<template>
  <div>
    <div class="kt-portlet bg-cart">
      <div class="kt-portlet__body kt-portlet__body--fit">
        <div class="d-flex align-items-center px-5" style="padding: 0.36rem;">
          <i class="flaticon2-shopping-cart-1 fa-2x kt-font-success"></i>
          <h4 class="kt-mycart__title ml-2 m-0">Order Summary</h4>
        </div>
      </div>
    </div>

    <OrderSummary>
      <template #footerBtns>
        <slot name="footerBtns"></slot>
      </template>
    </OrderSummary>
  </div>
</template>

<script>
import OrderSummary from "@/components/OrderSummary.vue";
export default {
  components: {
    OrderSummary,
  },
};
</script>

<style scoped>
.bg-cart {
  background-color: #fff8ee;
}
</style>
